<template>
    <!-- Modal -->
    <b-modal :visible="showModal"
  @hide="closeModal" id="interview-launch-modal" title="Interview launch modal" hide-footer hide-header centered no-close-on-backdrop>
       
   <section class="modal-body-section py-4">
    
    <img
      class="pointer section-close"
      src="../../assets/newdesign/dashboard/blueCross.svg"
      alt="close"
      @click="closeModal()"
    />
           
            <img src="../../assets/newdesign/myprofile/profilevisibility/launch.svg" alt="" class="vc-image">
            <article class="mt-4 text-center">
                <h2 class="text-h2 fs-18 fw-400 text-blue pc-txt">COMING SOON </h2>
                <h2 class="text-h2 fs-16 fw-600 text-lightgrey mt-2 vc-txt ">Stay tuned - our premium version with exclusive features is launching soon
                </h2>
            </article>
        </section>
    </b-modal>
</template>
<script>
export default {
    name: "InterviewModal",
    data() {
        return {};
    },

   props:{
    showModal:{
        type: Boolean,
        default:false
    }
   } ,
   methods: {
  closeModal() {
    this.$emit("update:showModal", false);
  }
}
};

</script>

<style>
.modal-body-section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.section-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 18px;
  cursor: pointer;
}



</style>
